import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CareConnectApp from './CareConnectApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CareConnectApp />
  </React.StrictMode>
);
